import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
const state = {
  serviceRequest: {
    date: new Date(),
    userId: null,
    isOnSite: true,
    createdBy: null,
    serviceJobsMeta: [],
    customerCall: false,
    isSiteVisited: false,
    externalGoodsMeta: {},
    externalGoodsTotal: 0,
    priority: "moderate",
    saleId: null,
    customerAddressId: null,
    temporaryPhone: ""
  },
  serviceRequestList: [],
  serviceRequestLogs: [],
  serviceRequestPointsTimeline: {
    totalPoints: 0,
    totalPenalty: 0,
    totalAwardedPoints: 0,
    unlinkedAwardedPoints: 0,
    unlinkedPointLogs: [],
    allPointLogs: [],
    timeline: []
  },
  serviceRequestStats: []
};

const serviceRequest = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default serviceRequest;
